import React from 'react';
import { Megaphone } from 'lucide-react';

interface AdBannerProps {
  width: number;
  height: number;
  label?: string;
  className?: string;
}

export default function AdBanner({ width, height, label, className = '' }: AdBannerProps) {
  return (
    <div
      className={`ad-banner-placeholder rounded-lg flex-col gap-1 ${className}`}
      style={{ width: '100%', maxWidth: width, height }}
    >
      <span className="text-sm font-bold text-muted-foreground inline-flex items-center gap-1.5"><Megaphone className="w-4 h-4" aria-hidden="true" />ADVERTISE HERE</span>
      <span className="text-xs text-muted-foreground">{label || `${width}×${height} Banner`}</span>
      <span className="text-xs text-muted-foreground">contact@farmtradedirect.com</span>
    </div>
  );
}